import styled from 'styled-components/macro';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const ShowCounterStyled = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
  width: 1233px;

  @media only screen and (max-width: 1277px) {
    width: 875px;
  }

  @media only screen and (max-width: 875px) {
    width: 615px;
    height: 139px;
  }

  @media only screen and (max-width: 620px) {
    width: 394px;
    height: 100px;
  }

  @media only screen and (max-width: 400px) {
    width: 284px;
  }
`;

export const ParentOfCount = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 1233px;
  height: 38px;

  @media only screen and (max-width: 1277px) {
    width: 875px;
  }

  @media only screen and (max-width: 875px) {
    width: 615px;
  }

  @media only screen and (max-width: 620px) {
    width: 394px;
    height: 100px;
  }

  @media only screen and (max-width: 400px) {
    width: 284px;
    height: 61px;
  }
`;

export const CountText = styled.span`
  width: 220px;
  color: ${COLORS.white};
  text-align: center;
  ${FONTS.font24}

  @media only screen and (max-width: 1277px) {
    width: 155px;
  }

  @media only screen and (max-width: 875px) {
    width: 110px;
    ${FONTS.font16}
    ${FONT_FAMILY.FontRegular}
  }

  @media only screen and (max-width: 620px) {
    width: 70px;
    ${FONTS.font14}
  }

  @media only screen and (max-width: 400px) {
    width: 57px;
  }
`;

export const MainCountTimer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 1233px;

  @media only screen and (max-width: 1277px) {
    width: 875px;
  }

  @media only screen and (max-width: 875px) {
    width: 615px;
  }

  @media only screen and (max-width: 620px) {
    width: 394px;
    height: 100px;
  }

  @media only screen and (max-width: 400px) {
    width: 284px;
    height: 61px;
  }
`;

export const DotsForTimer = styled.span`
  ${FONTS.font36}
  color: ${COLORS.white};
  ${FONT_FAMILY.FontBold}

  @media only screen and (max-width: 875px) {
    ${FONTS.font36}
  }

  @media only screen and (max-width: 620px) {
    ${FONTS.font36}
  }

  @media only screen and (max-width: 400px) {
    ${FONTS.font24}
  }
`;
